import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const appHeaderTitleClasses = generateClasses('AppHeaderTitle', [
  'root',
  'title',
  'svgContainer',
  'titleSvg',
] as const);

export const appHeaderTitleRootClasses = generateClasses(appHeaderTitleClasses.root, ['simple'] as const, true);

const styles: Styles = ({ theme }) => {
  const {
    appHeader: {
      text: { defaultTextColor, appTitleColor },
      customerLogo: { hideCustomerLogo },
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${appHeaderTitleClasses.root}`]: {
      display: hideCustomerLogo ? 'none' : 'block',
      userSelect: 'none',

      [`&.${appHeaderTitleRootClasses.simple}`]: {
        color: appTitleColor ?? defaultTextColor,
        fontSize: 18,
        fontFamily: 'LufthansaTextWeb',
        fontWeight: 700,
        letterSpacing: '-0.045rem',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },

    [`.${appHeaderTitleClasses.svgContainer}`]: {
      display: 'flex',
      width: 'auto',
      maxWidth: 100,
      height: 12,
    },

    [`.${appHeaderTitleClasses.titleSvg}`]: {
      objectFit: 'contain',
      objectPosition: 'left',
    },
  };
};
export default styles;
